import service from '@/config/axios'

// 用户登录
const loginUser = (model) => {
  return service.post('/api/user/login', model, { rawResponse: true })
}

// 用户注册
const registerUser = (model) => {
  return service.post('/api/user/register', model, { rawResponse: true })
}

// 忘记密码 - 发送邮箱验证码
const forgotpassword = (email) => {
  return service.get('/api/user/forgotpassword', { params: { email } })
}

// 修改密码
const changepassword = (model) => {
  return service.post('/api/user/changepassword', model, { rawResponse: true })
}

// 获取用户信息
const getUserInfo = (userId) => {
  return service.get(`/api/user/info/${userId}`)
}

// 更新用户信息
const updateUserInfo = (model) => {
  return service.post('/api/user/update', model)
}

// 用户退出登录
const logoutUser = () => {
  return service.post('/api/user/logout')
}

export { loginUser, registerUser, forgotpassword,changepassword, getUserInfo, updateUserInfo, logoutUser }
